module.exports = __webpack_public_path__ + "img/newsDemo.a16dab03.png";